import { Common, color } from '@stockbit/ui';

const { Iconmoon, IconWrapper } = Common;

type propTypes = {
  isActive: boolean;
  onClick: (e: MouseEvent) => void;
};

const Iconplus = ({ isActive, onClick }: propTypes) => (
  <IconWrapper onClick={onClick} padding="12px 0" className="icon-wrapper">
    <Iconmoon
      className="icon-compose_plus"
      size="16px"
      color={color.highempahis}
      hoverColor={color.highempahis}
    />
    <style jsx>
      {`
        .icon-wrapper {
          display: ${isActive ? 'flex' : 'none'};
        }
      `}
    </style>
  </IconWrapper>
);

export default Iconplus;
